import {PreviewLayoutKey, PreviewProps} from 'sanity'
import type {OembedData} from '@extractus/oembed-extractor'
import {useEffect, useState} from 'react'
import {ComponentPreview} from '@/schemaTypes/portable-text/ComponentPreview'

const fetchOembed = async (url: string): Promise<OembedData> => {
  const requestUrl = new URL(`${process.env.SANITY_STUDIO_BLOG_BASE_URL}/blog/api/oembed-proxy`)
  requestUrl.searchParams.append('url', encodeURI(url))
  const response = await fetch(requestUrl.toString())
  const data = await response.json()
  return data
}

const OEmbedPreview: React.FC<PreviewProps<PreviewLayoutKey>> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const url = (props as any).url

  const [response, setResponse] = useState<OembedData | null>(null)
  useEffect(() => {
    // NOTE: if I use the "use" hook it re-fetch on every click
    const getOEmbedMetadata = () => fetchOembed(url).then(setResponse)
    getOEmbedMetadata()
  }, [url])

  if (!url || !response) {
    return (
      <ComponentPreview
        {...props}
        title={url ? 'Error fetching oembed preview' : 'Missing URL'}
        shadow={false}
      ></ComponentPreview>
    )
  }

  return (
    <ComponentPreview
      {...props}
      shadow={false}
      title={response.title}
      layout="blockImage"
      media={
        <img
          src={response.thumbnail_url}
          width={response.thumbnail_width}
          height={response.thumbnail_height}
          alt={response.title}
        />
      }
    ></ComponentPreview>
  )
}

export default OEmbedPreview
